import { render, staticRenderFns } from "./TasksTypesModal.vue?vue&type=template&id=7990bd34&scoped=true&"
import script from "./TasksTypesModal.vue?vue&type=script&lang=ts&"
export * from "./TasksTypesModal.vue?vue&type=script&lang=ts&"
import style0 from "./TasksTypesModal.vue?vue&type=style&index=0&id=7990bd34&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7990bd34",
  null
  
)

export default component.exports